<script setup lang="ts">
import UiPdfEmbed from '@/components/UiPdfEmbed/UiPdfEmbed.vue'
import VimeoPlayer from '@/components/VimeoPlayer/VimeoPlayer.vue'
const { t, locale } = useI18n()

useHead({
  title: t('pageTitles.keyCloakUserguide.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.keyCloakUserguide.meta'),
    },
  ],
  link: [
    {
      hid: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico',
    },
    {
      rel: 'canonical',
      href: t(`pageTitles.keyCloakUserguide.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.keyCloakUserguide.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.keyCloakUserguide.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.keyCloakUserguide.canonical.pl'),
    },
  ],
})

</script>

<template>
  <div>
    <UiSection color="gray">
      <UiHeader
        position="center"
        :header="$t('oneKeycloak.header')"
        :subheader="$t('oneKeycloak.subheader')"
      />
      
      <VimeoPlayer
        :src="$t('oneKeycloak.videoSource')"
        :title="$t('oneKeycloak.subheader')"
      />
    </UiSection>

    <UiPdfEmbed
      :source="$t('oneKeycloak.documentSource')"
      :button-label="$t('common.openInNewWindow')"
    />
  </div>
</template>

<style lang="scss" scoped>
:deep(.ui-header) {
  display: block;
  margin-top: 4.8rem;

  @include atM{
    margin-top: 9.6rem;
  }
}
:deep(.ui-header__subheader) {
  display: block;
  margin: 0 auto 4.8rem auto;
  
  @include atM{
    margin: 0 auto 9.6rem auto;
  }
}
</style>
